import React, { useEffect, useState } from "react";
import Style from "./SupermarketProduct.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { getSearchProductsApi } from "../../../Api/SupplierServices";
import "./SupermarketProduct.css";
import MenuTitle from "../../MenuTitlle/MenuTitle";
import AddProductToStore from "../AddProductToStore/AddProductToStore";
import AddNewProduct from "../AddNewProduct/AddNewProduct";

const SupermarketProduct = () => {
  ///////////// States Part ///////////////////////
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState([]);
  const [showSearchPart, setShowSearchPart] = useState(false);
  const [productData, setProductData] = useState();

  const [onclickPlus, setOnclickPlus] = useState(false);
  const [onclickLi, setOnclickLi] = useState(false);
  const [addNewProduct, setAddNewProduct] = useState(true);
  const [addExistProduct, setAddExistProduct] = useState(true);

  /////////////////// handle requsts of search input ////////////////
  useEffect(() => {
    let debounceTimer;

    const getSearchProduct = async (e) => {
      const result = await getSearchProductsApi(searchTerm);

      const sortedResult = result.product.sort((a, b) => {
        if (a.score > b.score) {
          return -1;
        } else if (a.sscore < b.score) {
          return 1;
        } else return 0;
      });
      setSearchValue(sortedResult);
      if (searchTerm === "") {
        setShowSearchPart(false);
      } else {
        setShowSearchPart(true);
      }
    };

    const debounceSearch = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        getSearchProduct();
      }, 200);
    };
    debounceSearch();
    return () => {
      clearTimeout(debounceTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  /////////////// get search input value /////////////////////////
  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  /////////////// click li and get detail //////////////////////
  const clickProductHandler = (item) => {
    setOnclickLi(true);
    setOnclickPlus(false)
    setShowSearchPart(false);
    setProductData(item);
  };

  let centerComponent = null;
  if (onclickLi) {
    centerComponent = <AddProductToStore productData={productData} />;
  } 
  if (onclickPlus) {
    centerComponent = <AddNewProduct />
  }

  return (
    <div className={Style.componentHolder}>
      <MenuTitle title={"افزودن محصول"} />
      <div className={Style.selectHolder}>
        <>
          <FontAwesomeIcon
            icon={faPlus}
            className={Style.plusIcon}
            onClick={() => {
              setShowSearchPart(false);
              setOnclickPlus(true);
              setOnclickLi(false);
            }}
          />
          <input
            className={Style.searchProduct}
            placeholder={" نام محصول"}
            value={searchTerm}
            onChange={handleInputChange}
          />
        </>
        {!showSearchPart ? null : (
          <ul className={Style.searchResult}>
            {searchValue.length === 0 && searchTerm !== "" ? (
              <p>درحال بررسی</p>
            ) : (
              searchValue.map((item, index) => {
                return (
                  <li
                    onClick={() => clickProductHandler(item)}
                    className={Style.resultItem}
                    key={index}
                  >
                    <div className={Style.imgHolder}>
                      <img
                        src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                        alt=""
                      />
                    </div>
                    {item.name}
                  </li>
                );
              })
            )}
          </ul>
        )}
      </div>
      {centerComponent}
    </div>
  );
};

export default SupermarketProduct;
